import { useForm } from '@givebacks/formy';
import { Checkbox, Group, Stack, Text, ThemeIcon, Tooltip } from 'ui';
import { InfoIcon } from 'ui/Icons';

type Props = {
  causeName?: string;

  onChange?: (data: boolean) => void;
  isCoveringFees?: boolean;
  checkoutFee?: number;
  pledgeRequired?: boolean;
};

export type ProcessingFeesFormType = {
  absorb_fees: boolean;
};

const ProcessingFeesForm = ({
  onChange,
  causeName,
  pledgeRequired,
  checkoutFee,
  isCoveringFees,
}: Props) => {
  const form = useForm<ProcessingFeesFormType>(
    {
      initialValues: {
        absorb_fees: !!isCoveringFees,
      },
    },
    {
      id: 'processing_fees',
    }
  );

  return (
    <Group align="top" wrap="nowrap">
      <Checkbox
        label={null}
        id="cover-fees"
        {...form.getInputProps('absorb_fees', {
          type: 'checkbox',
        })}
        onChange={(event) => {
          onChange?.(event.currentTarget.checked);
          form.getInputProps('absorb_fees').onChange(event);
        }}
      />
      <Stack style={{ flexGrow: 1 }} gap="xs">
        <Group gap="xs" justify="space-between">
          <Text fz="sm" fw={600}>
            I want to cover processing fee
          </Text>
          <Tooltip
            maw="268px"
            label="Fees may be applied differently for select items based on cause preferences. Click View Breakdown for more information."
          >
            <ThemeIcon color="transparent" c="cobalt" size={20}>
              <InfoIcon style={{ width: '100%' }} />
            </ThemeIcon>
          </Tooltip>
        </Group>
        {checkoutFee && form.values.absorb_fees && !pledgeRequired ? (
          <Text fz="xs" c="gray">
            <span>I would like to add </span>{' '}
            <span>
              {`to cover payment processing fees. This allows more of my 
                      donation
                    to benefit`}
            </span>{' '}
            <span>{causeName}.</span>
          </Text>
        ) : (
          <Text fz="xs" c="gray">
            {`I would like to add the processing fees to my payment. This allows more of my
                  donation to benefit `}
            <span>{causeName}.</span>
          </Text>
        )}
      </Stack>
    </Group>
  );
};

export { ProcessingFeesForm };
